export const OBSERVER_DELAY = 200;
